<template>

  <div class="mzixunWrap">
    <div class="mzixunLeft white">
      <div class="abstractIitem">
        <div class="itemTile">
          <h3>招生章程</h3>
        </div>
        <div class="admissions">
          <div class="admissionsLink">
            <router-link to="">{{obj.zcName}}</router-link>
            <div class="flex-between">
              <span>发布时间：{{obj.creatTime}}</span>
              <!-- <span>浏览459</span> -->
            </div>
          </div>
          <div class="admissionsText" style="padding-top: 20px;" v-html="content">

          </div>

        </div>
      </div>
    </div>

    <div class="abstractRight white">
      <div class="abstractIitem">
        <div class="itemTile">
          <h3>历年招生简章</h3>
        </div>
        <ul class="admissionsList">
          <li v-for="(item,index) in  collegeZc" @click="getZc(item)">
            <router-link to="">{{item.zcName}}</router-link>
            <div class="flex-between">
              <span>发布时间：{{item.creatTime}}</span>
              <!-- <span>浏览459</span> -->
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: "",

    data() {
      return {
        collegeZc: [],
        content: '',
        obj: {},
      }
    },
    props: {
      id: {
        type: String,
        default: ''
      }
    },
    created() {
      let _this = this;
      this.$req.queryAllByLimit("collegeZc", {
        pageSize: 4,
        pageNum: 1,
        queryObj: {
          collegeId: this.id
        }
      }).then(function(response) {
        _this.collegeZc = response.data         
         if (_this.collegeZc.length != 0) {
          _this.getZc(_this.collegeZc[0])
        }
      })
    },
    methods: {
      getZc(obj) {
        let _this = this;
        this.obj = obj
        _this.$http.get(_this.$resourcesUrl + "/collegezc/" + this.id + "/" + obj.zcId + ".html").then(function(
          response) {
          _this.content = response
        })
      }
    }


  }
</script>

<style scoped>
  .wrap {
    background: #FBFBFB;
  }

  /* 右边固定 */
  .zuotab {
    height: auto;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 50%;
    right: 0px;
    transform: translate(-50%, -50%);
  }

  .zuotab figure {
    cursor: pointer;
    margin: 8px 0;
    width: 64px;
    height: 62px;
    border: 1px solid #FF0000;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .zuotab figure img {
    width: 20px;
    height: 20px;
  }

  .zuotab figure figcaption {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    margin-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/information/collegeinfo/xyzy_zhaoshengjianzhang.vue